import initSidebarSettings from './sidebar-settings';
import initSettingsForm from './settings-form';
import './index.sass';
import './black-list/index.sass';
import './settings-checkbox/index.sass';

export default () => {
  initSettingsForm();
  initSidebarSettings();
}